import { Controller } from "stimulus"

import UploadAdapter from './upload_adapter';



// function AddPageInfoStyle( editor ) {
//     // Both the data and the editing pipelines are affected by this conversion.
//     editor.conversion.for( 'downcast' ).add( dispatcher => {
//         // Links are represented in the model as a "linkHref" attribute.
//         // Use the "low" listener priority to apply the changes after the link feature.
//         dispatcher.on( 'attribute:linkHref', ( evt, data, conversionApi ) => {
//             const viewWriter = conversionApi.writer;
//             const viewSelection = viewWriter.document.selection;

//             // Adding a new CSS class is done by wrapping all link ranges and selection
//             // in a new attribute element with the "target" attribute.
//             const viewElement = viewWriter.createAttributeElement( 'a', {
//                     target: '_blank'
//                 }, {
//                     priority: 5
//                 } );

//             if ( data.attributeNewValue.match( /ckeditor\.com/ ) ) {
//                 viewWriter.unwrap( conversionApi.mapper.toViewRange( data.range ), viewElement );
//             } else {
//                 if ( data.item.is( 'selection' ) ) {
//                     viewWriter.wrap( viewSelection.getFirstRange(), viewElement );
//                 } else {
//                     viewWriter.wrap( conversionApi.mapper.toViewRange( data.range ), viewElement );
//                 }
//             }
//         }, { priority: 'low' } );
//     } );
// }

function CustomUploadAdapterPlugin( editor ) {
    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        return new UploadAdapter( loader, editor );
    };
}

// function ConvertParagraphAttributes( editor ) {

//     editor.model.schema.addAttributeCheck( context => {
//         if ( context.endsWith( 'p' ) ) {
//             return true;
//         }
//     } );

//     editor.conversion.for( 'upcast' ).elementToElement( {
//         view: 'paragraph',
//         model: ( viewElement, { writer: modelWriter } ) => {
//             return modelWriter.createElement( 'paragraph', viewElement.getAttributes() );
//         }
//     } );

//     editor.conversion.for( 'downcast' ).elementToElement( {
//         model: 'paragraph',
//         view: 'paragraph'
//     } );


//     editor.conversion.for( 'downcast' ).add( dispatcher => {
//         dispatcher.on( 'attribute', ( evt, data, conversionApi ) => {

//             if ( data.item.name != 'paragraph' ) {
//                 return;
//             }

//             const viewWriter = conversionApi.writer;
//             const viewP = conversionApi.mapper.toViewElement( data.item );

//             // In the model-to-view conversion we convert changes.
//             // An attribute can be added or removed or changed.
//             // The below code handles all 3 cases.
//             if ( data.attributeNewValue ) {
//                 viewWriter.setAttribute( data.attributeKey, data.attributeNewValue, viewP );
//             } else {
//                 viewWriter.removeAttribute( data.attributeKey, viewP );
//             }
//         } );
//     } );
// }

function ConvertDivAttributes( editor ) {
				// Allow <div> elements in the model.
				editor.model.schema.register( 'div', {
						allowWhere: '$block',
						allowContentOf: '$root'
				} );

				// Allow <div> elements in the model to have all attributes.
				editor.model.schema.addAttributeCheck( context => {
						if ( context.endsWith( 'div' ) ) {
								return true;
						}
				} );

				// The view-to-model converter converting a view <div> with all its attributes to the model.
				editor.conversion.for( 'upcast' ).elementToElement( {
						view: 'div',
						model: ( viewElement, { writer: modelWriter } ) => {
								return modelWriter.createElement( 'div', viewElement.getAttributes() );
						}
				} );

				// The model-to-view converter for the <div> element (attributes are converted separately).
				editor.conversion.for( 'downcast' ).elementToElement( {
						model: 'div',
						view: 'div'
				} );

				// The model-to-view converter for <div> attributes.
				// Note that a lower-level, event-based API is used here.
				editor.conversion.for( 'downcast' ).add( dispatcher => {
						dispatcher.on( 'attribute', ( evt, data, conversionApi ) => {
								// Convert <div> attributes only.
								if ( data.item.name != 'div' ) {
										return;
								}

								const viewWriter = conversionApi.writer;
								const viewDiv = conversionApi.mapper.toViewElement( data.item );

								// In the model-to-view conversion we convert changes.
								// An attribute can be added or removed or changed.
								// The below code handles all 3 cases.
								if ( data.attributeNewValue ) {
										viewWriter.setAttribute( data.attributeKey, data.attributeNewValue, viewDiv );
								} else {
										viewWriter.removeAttribute( data.attributeKey, viewDiv );
								}
						} );
				} );
		}




	function ConvertAnchorAttributes( editor ) {



			// Allow <a> elements in the model to have all attributes.
			editor.model.schema.addAttributeCheck( context => {
					if ( context.endsWith( 'a' ) ) {
							return true;
					}
			} );

		
	}




export default class extends Controller {

	static targets = ["editor"]

 connect(){

  var watchdog = new CKSource.EditorWatchdog();
			window.watchdog = watchdog;

			watchdog.setCreator( ( element, config ) => {
				return CKSource.Editor
					.create( element, {
            ...config,
            htmlSupport: {
            allow: [
              {
                name: 'u',
                               attributes: true,
                classes: true,
                styles: true
              }
            ],
          }
        } )
					.then( editor => {
				
            editor.model.schema.extend('$text', { allowAttributes: 'customUnderlineStyle' });

editor.model.schema.extend('$text', { allowAttributes: ['attHighlight'] });



//editor.conversion.for('downcast').attributeToElement({
//  model: 'attHighlight',
//  view: (attId, { writer }) => {
//    return writer.createAttributeElement('span', {
//      class: 'highlighted',
//      'data-att-id': attId
//    }, {
//      priority: 5,
//      id: `highlight-${attId}`
//    });
//  },
//  converterPriority: 'high'
//});


editor.conversion.for('editingDowncast').attributeToElement({
  model: 'attHighlight',
  view: (attId, { writer }) => {
    const element = writer.createAttributeElement('span', {
      class: 'highlighted',
      'data-att-id': attId
    }, {
      priority: 5,
      id: `highlight-${attId}`,
      renderUnsafeAttributes: ['data-att-id']
    });

    writer.setCustomProperty('attHighlight', true, element);
    return element;
  },
  converterPriority: 'high'
});
            // Upcast converter for <u style="...">
       //     editor.conversion.for('upcast').attributeToAttribute({
       //       view: {
       //         name: 'u',
       //         key: 'style',
       //       },
       //       model: 'customUnderlineStyle'
       //     });


editor.conversion.for('upcast').elementToAttribute({
    view: {
        name: 'u',
        styles: {
            'text-decoration-color':'blue',// matches any color
        }
    },
    model: {
        key: 'customUnderlineStyle',
        value: viewElement => viewElement.getAttribute('style')
    }
});

// Downcast converter to output <u style="...">
editor.conversion.for('downcast').attributeToElement({
  model: 'customUnderlineStyle',
  view: (modelAttributeValue, { writer: viewWriter }) => {
    if (modelAttributeValue) {
      return viewWriter.createAttributeElement('u', { style: modelAttributeValue }, { priority: 5 });
    }
    return null;
  }
});

// Helper to apply custom style underline to selection
window.applyCustomUnderlineStyle = function(styleString) {
  editor.model.change(writer => {
    const selection = editor.model.document.selection;
    var selectionAttributes = Array.from(selection.getAttributes());
  //  if ((selection.hasAttribute("htmlU") || selection.hasAttribute("customUnderlineStyle"))) {
  //    removeUnderlineFromSelection();
  //    return;
  //}
    for (const range of selection.getRanges()) {
      writer.setAttribute('customUnderlineStyle', styleString, range);
      document.querySelector(".toggle-underline-color-btn").classList.add("active-on-selected-text");
      writer.setSelection(range);
    editor.editing.view.focus()
    }
  });
};



document.querySelector('.toggle-underline-color-btn').addEventListener('click', function(e) {
  var selection = editor.model.document.selection;
  console.log("selection")
  console.log(selection.hasAttribute("customUnderlineStyle"))
  if (selection.hasAttribute("underline") || selection.hasAttribute("customUnderlineStyle")) {
    window.removeUnderlineFromSelection();
    document.getElementById("underlineColorSelectionPopup").classList.add("hidden");
  } else {
    document.getElementById("underlineColorSelectionPopup").classList.remove("hidden");
  }

});

document.querySelector('.ck-content').addEventListener('click', function(e) { 
  document.getElementById("underlineColorSelectionPopup").classList.add("hidden");
});


editor.model.document.selection.on('change:range', (evt, data) => {
    
    // Get selected text
    const selection = editor.model.document.selection;
    if (selection.isCollapsed) {
      document.querySelector(".toggle-underline-color-btn").classList.remove("active-on-selected-text");
      return;
    }

    if ((selection.hasAttribute("htmlU") || selection.hasAttribute("customUnderlineStyle"))) {
      document.querySelector(".toggle-underline-color-btn").classList.add("active-on-selected-text");
    } else {
      document.querySelector(".toggle-underline-color-btn").classList.remove("active-on-selected-text");
    }
});



window.removeUnderlineFromSelection = function() {
    const model = window.editor.model;

    model.change(writer => {
        const selection = model.document.selection;

        // Remove 'underline' attribute
        if (selection.hasAttribute('underline')) {
            writer.removeSelectionAttribute('underline');
        }

        // Remove 'htmlU' attribute (from html-support plugin)
        if (selection.hasAttribute('htmlU')) {
            writer.removeSelectionAttribute('htmlU');
        }

        // Also remove from selected text if not just caret selection
        for (const range of selection.getRanges()) {
            for (const item of range.getItems()) {
                if (item.hasAttribute('underline')) {
                    writer.removeAttribute('underline', item);
                }
                if (item.hasAttribute('htmlU')) {
                    writer.removeAttribute('htmlU', item);
                }

                if (item.hasAttribute('customUnderlineStyle')) {
                    writer.removeAttribute('customUnderlineStyle', item);
                  }
            }
        }

        document.querySelector(".toggle-underline-color-btn").classList.remove("active-on-selected-text");
    });
}

//window.clearCustomUnderlineStyle = function() {
//    editor.model.change(writer => {
//        const selection = editor.model.document.selection;
//        for (const range of selection.getRanges()) {
//            writer.removeAttribute('underline', range);
//            writer.removeAttribute('customUnderlineStyle', range);
//        }
//    });
//};



    editor.editing.view.document.on('click', (evt, data) => {
      const domTarget = data.domTarget;
      if (domTarget?.closest('.highlighted')) {
        const span = domTarget.closest('.highlighted');
        const attId = span.getAttribute('data-att-id');
        var attachmentsModalBtn = document.querySelector(".editor-open-attachments-modal");
        var attachmentsModalUrl = attachmentsModalBtn.href;
        var originalAttachmentsModalUrl = attachmentsModalUrl;
        if (attachmentsModalBtn.href.includes("load_attachment=")) return;
        attachmentsModalBtn.href = attachmentsModalUrl + "?load_attachment=" + attId;
        attachmentsModalBtn.click();
        setTimeout(() => {
          attachmentsModalBtn.href = originalAttachmentsModalUrl; 
        }, 100);
      }
    });



      window.editor = editor;



      if (!!window.attachmentsTextsWithIds) {
        var shouldRemoveHighlight = false;
        document.querySelector('.toggle-names-highlight-btn').addEventListener('click', function(e) {
          shouldRemoveHighlight = !shouldRemoveHighlight;


          shouldRemoveHighlight ? window.highlightWordsInEditor(attachmentsTextsWithIds) : window.clearHighlightsInEditor();
        });
      }










						return editor;
					} )
			} );

			watchdog.setDestructor( editor => {
				return editor.destroy();
			} );
			
			watchdog.on( 'error', handleError );
		





      if (document.querySelector(".ck-editor") == null) {

        		watchdog
				.create( this.element, {
			
            extraPlugins: [ CustomUploadAdapterPlugin, ConvertDivAttributes ],
            customUpload: {
              directUploadUrl: this.element.dataset.directUploadUrl,
              blobUrlTemplate: this.element.dataset.blobUrlTemplate
						},

				toolbar: {
					items: [
						'heading',
						'|',
						'bold',
						'italic',
						'underline',
						'strikethrough',
						'alignment',
						'fontSize',
						'fontFamily',
						'fontColor',
						'fontBackgroundColor',
						'bulletedList',
						'numberedList',
						'removeFormat',
						'horizontalLine',
						'|',
						'outdent',
						'indent',
						'|',
						'link',
						'imageUpload',
						'blockQuote',
						'insertTable',
						'findAndReplace',
						'|',
						'undo',
						'redo',
						'imageInsert',
						'todoList',
						'highlight',
						'specialCharacters',
						'htmlEmbed',
						'sourceEditing',
						'textPartLanguage'
					]
				},
				language: 'it',
        link: {
          addTargetToExternalLinks: true,          
        
        },
				image: {
					toolbar: [
						'imageStyle:inline',
						'imageStyle:block',
						'imageStyle:side',
						'linkImage',
						'toggleImageCaption',
					]
				},
				table: {
					contentToolbar: [
						'tableColumn',
						'tableRow',
						'mergeTableCells',
						'tableCellProperties',
						'tableProperties'
					]
				},
		
					licenseKey: '',
					
					
					
				} )
				.catch( handleError );

      }
			
	
			
			function handleError( error ) {
				console.error( 'Oops, something went wrong!' );
				console.warn( 'Build id: ls5tuf113001-x3u550otkmj9' );
				console.error( error );
			}





    window.highlightWordsInEditor = function(wordsWithIds) {
      const model = editor.model;
      const root = model.document.getRoot();

      model.change(writer => {
        const rangesToHighlight = [];

        for (const value of model.createRangeIn(root).getWalker({ ignoreElementEnd: true })) {
          const item = value.item;

          if (!item || !item.is('$textProxy')) continue;

          const parent = item.parent;
          if (!parent || parent.name !== 'paragraph') continue;

          const text = item.data;

          for (const { word, attId } of wordsWithIds) {
            if (!word || typeof word !== 'string') continue;

            const regex = new RegExp(word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
            let match;

            while ((match = regex.exec(text)) !== null) {
              const startOffset = item.startOffset + match.index;
              const start = model.createPositionAt(parent, startOffset);
              const end = start.getShiftedBy(word.length);

              const range = model.createRange(start, end);
              rangesToHighlight.push({ range, attId });
            }
          }
        }

        for (const { range, attId } of rangesToHighlight) {
          try {
           writer.setAttribute('attHighlight', attId, range);
          } catch (e) {
            console.warn('Highlighting error:', e);
          }
        }
      });
    };



window.clearHighlightsInEditor = function() {
  const model = editor.model;
  const root = model.document.getRoot();

  model.change(writer => {
    for (const value of model.createRangeIn(root).getWalker({ ignoreElementEnd: true })) {
      const item = value.item;

      if (!item || !item.is('$textProxy')) continue;

      if (item.hasAttribute('attHighlight')) {
        writer.removeAttribute('attHighlight', item);
      }
    }
  });
};


      
   }

	 openUploadModal() {
		 document.querySelectorAll("#upload_modal").classList.remove("hidden")
	 }



}
